import React, { useState } from 'react';
import FusePageCarded from '@fuse/core/FusePageCarded';
import FuseAnimate from '@fuse/core/FuseAnimate';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import AppsIcon from '@mui/icons-material/Apps';
import PeopleIcon from '@mui/icons-material/People';
import GlobalTabs from 'allGlobalComponents/GlobalTabs';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';

// Import tab components
import ChannelsTab from './tabs/ChannelsTab';
import MetaAppsTab from './tabs/MetaAppsTab';
import ChannelAppsTab from './tabs/ChannelAppsTab';
import ClientChannelsTab from './tabs/ClientChannelsTab';
import WhatsAppAccountsTab from './tabs/WhatsAppAccountsTab';


const useStyles = makeStyles(theme => ({
    contentContainer: {
        padding: theme.spacing(2),
        width: '100%'
    }
}));

const TABS = [
    { id: 'channels', label: 'Channels', icon: SettingsInputAntennaIcon },
    { id: 'meta-apps', label: 'Meta Apps', icon: AllInclusiveIcon },
    { id: 'channel-apps', label: 'Channel Apps', icon: AppsIcon },
    { id: 'client-channels', label: 'Client Channels', icon: PeopleIcon },
    { id: 'whatsapp-accounts', label: 'WhatsApp Accounts', icon: WhatsAppIcon },
];

function SaChannels() {
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState('channels');

    const renderTabContent = () => {
        switch (activeTab) {
            case 'channels':
                return <ChannelsTab />;
            case 'meta-apps':
                return <MetaAppsTab />;
            case 'channel-apps':
                return <ChannelAppsTab />;
            case 'client-channels':
                return <ClientChannelsTab />;
            case 'whatsapp-accounts':
                return <WhatsAppAccountsTab />;
            default:
                return <ChannelsTab />;
        }
    };

    return (
        <FusePageCarded
            header={
                <div className="flex flex-1 w-full items-center justify-between flex-wrap">
                    <div className="hidden sm:flex items-center">
                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <SettingsInputAntennaIcon fontSize="large" />
                        </FuseAnimate>
                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                            <Typography className="flex mx-0 sm:mx-12" variant="h6">
                                <span style={{ fontSize: '15px' }}>Channels</span>
                            </Typography>
                        </FuseAnimate>
                    </div>
                </div>
            }
            content={
                <div className={classes.contentContainer}>
                    <GlobalTabs
                        tabs={TABS}
                        activeTab={activeTab}
                        onChange={setActiveTab}
                    />
                    {renderTabContent()}
                </div>
            }
        />
    );
}

export default SaChannels;